module.exports = __webpack_public_path__ + "img/menu.25977f33.svg";